// extracted by mini-css-extract-plugin
export var container = "styles-module--container--8fac3";
export var content = "styles-module--content--115f9";
export var fluid = "styles-module--fluid--47d9d";
export var nextButton = "styles-module--nextButton--25ea9";
export var tail = "styles-module--tail--4649f";
export var tailLeft = "styles-module--tailLeft--12a25";
export var tailRight = "styles-module--tailRight--32254";